import { createRoute } from "@tanstack/solid-router";
import { plannedRoute } from "./planned";

export const plannedTodoRoute = createRoute({
  getParentRoute: () => plannedRoute,
  path: "/todo/$todoId",
  component: PlannedTodoDetailRoutePage,
});

function PlannedTodoDetailRoutePage() {
  return null;
}
